import { Container } from './Container';
import { VirtualContainer } from './VirtualContainer';
import * as ViewerHelpers from './helpers';

const enableVirtualForm = localStorage.getItem('enableVirtualForm');
const Viewer = enableVirtualForm ? VirtualContainer : Container;

export { Viewer, ViewerHelpers };
